import type { Release } from '../releases';

export default {
  id: '2026-11-01-budget-item-cost',
  at: '2026-11-02T03:45:00Z',
  title: 'Себестоимость раздела бюджета по позициям сметы',
  modules: ['budget'],
  items: [
    'В окне «Себестоимость» раздела бюджета — кнопка «Себестоимость по позициям сметы»: план выбранного варианта исполнения разложен по позициям привязанных смет — материалы, оборудование, работы, накладные — рядом со сметной стоимостью и маржой каждой позиции.',
    'Сумма по позициям равна себестоимости варианта до тиына. Если вариант не выбран, по позициям раскладывается сумма раздела. Из позиции можно перейти в смету.',
  ],
  why: 'Себестоимость была видна только целиком по разделу — не было понятно, на каких позициях сметы теряется маржа.',
  link: '/projects',
} satisfies Release;
